var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26711 11.8159C6.03743 11.577 6.04488 11.1972 6.28374 10.9675L9.43395 8L6.28375 5.0325C6.04488 4.80282 6.03743 4.423 6.26711 4.18413C6.49679 3.94527 6.87661 3.93782 7.11548 4.1675L10.7155 7.5675C10.8331 7.68062 10.8996 7.83679 10.8996 8C10.8996 8.16321 10.8331 8.31938 10.7155 8.4325L7.11548 11.8325C6.87661 12.0622 6.49679 12.0547 6.26711 11.8159Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.03c8f6b45c987ef50fd25d978ce847ef.svg";
export { ForwardRef as ReactComponent };